import { createContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import i18n from "../i18n/i18n";
import { setLanguage } from "../redux/language/languageSlice";

export const LanguageContext = createContext();

const LanguageProvider = ({ children }) => {
  const dispatch = useDispatch();
  const [language, setLanguageState] = useState(i18n.language || "en");

  useEffect(() => {
    const handleLanguageChange = (lng) => {
      setLanguageState(lng);
      dispatch(setLanguage(lng));
    };

    i18n.on("languageChanged", handleLanguageChange);
    return () => i18n.off("languageChanged", handleLanguageChange);
  }, [dispatch]);

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageProvider;